import { call, put } from 'redux-saga/effects';
import { deleteAnalyticTeam } from '../../../../state/analytic/analyticTeamSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* deleteTeamSaga(action) {
    const { teamId } = action.payload || {};
    try {
        yield call([backendClient, backendClient.delete], `teams/${encodeURIComponent(teamId)}`);
        yield put(deleteAnalyticTeam(teamId));
        yield put(showSnackbar({
            message: `Team deleted successfully.`,
            severity: 'success',
        }));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to delete analytic team', status, err?.message);
        yield put(showSnackbar({
            message: `Failed to delete team.`,
            severity: 'error',
        }));
    }
}